import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { RedDeleteIcon } from "../../../assets/images";

type AppProps = {
  toggle: () => void;
  isOpen: boolean;
  title: string;
  message?: string;
  onPressConfirm: () => void;
};
const DeleteConfirmationModal = ({
  toggle,
  isOpen,
  onPressConfirm,
  title,
  message,
}: AppProps) => {
  return (
    <>
      <Modal
        centered
        isOpen={isOpen}
        toggle={toggle}
        size="sm"
        style={{ minWidth: "355px" }}
        backdrop="static"
      >
        <ModalHeader
          style={{ border: "none", paddingBottom: "0px" }}
          toggle={toggle}
        ></ModalHeader>

        <ModalBody>
          <div className="d-flex justify-content-center flex-column align-items-center text-center pl-3 pr-3 pb-3">
            <img
              src={RedDeleteIcon}
              style={{ width: "50px" }}
              alt="delete-icon"
            />

            <div
              className="mt-3"
              style={{ fontSize: "20px", fontWeight: 500, color: "#262a44" }}
            >
              {title}
            </div>
            <div
              className="mt-3"
              style={{ color: "#262a44", fontWeight: "normal" }}
            >
              {message}
            </div>
          </div>
          <div className="p-3">
            <div className="mt-2">
              <button
                className="btn btn-primary w-100"
                onClick={onPressConfirm}
              >
                Delete
              </button>
            </div>
            <div className="mt-2">
              <button
                style={{ border: "1px solid #dd4433" }}
                className="btn w-100"
                onClick={toggle}
              >
                Cancel
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default DeleteConfirmationModal;
